import { render } from "./AwaitingButton.vue?vue&type=template&id=47b6418e"
import script from "./AwaitingButton.vue?vue&type=script&lang=js"
export * from "./AwaitingButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__